<template>
    <div>
        <div class="modal fade" id="limitModalJm" tabindex="-1" aria-hidden="true" data-bs-backdrop="false"
            style="background-color:rgba(0, 0, 0, 0.5);">
            <div class="modal-dialog modal-dialog-centered bet-limits-dialog">
                <div class="modal-content" style="background-color: rgba(60,60,60,.95);">
                    <div class="modal-header2 p-0">
                        <h6 class="modal-title">
                            Limites de apuestas
                            <button style="background:transparent;color:white" type="button" class="btn-close ms-auto"
                                data-bs-dismiss="modal" aria-label="Close"><i class="fas fa-times"></i></button>
                        </h6>
                    </div>
                    <div class="modal-body text-white">
                        <div v-for="(row, index) in limitsRows" :key="index" class="d-flex mb-2" style="font-size:13px;">
                            <span style="width:70%">{{ row.label }}</span>
                            <span style="width:30%;text-align:right">{{ row.value }}</span>
                        </div>
                        <div class="mt-4" style="font-size:11.2px;font-style:italic; padding-top:24px; font-weight:650; font-family: Metropolis, sans-serif;">
                            • Las apuesta que excedan estos limites serán rechazadas.
                        </div>
                        <div class="text-center mt-4">
                            <button class="close-btn" data-bs-dismiss="modal">CERRAR</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "betLimitsModal",
    data() {
        return {
            limitsRows: [
                { label: "Deportes", value: "1.500.000" },
                { label: "Casino Vivo", value: "300.000" },
                { label: "Caballos", value: "300.000" },
                { label: "Slots", value: "15.000" }
            ]
        };
    }
}
</script>

<style scoped>
.bet-limits-dialog {
    max-width: 500px;

}

.modal-body {
   padding: 24px 24px 18px 24px !important;
   font-family: Metropolis, sans-serif;
   font-weight: 500;
}

.modal-header2 {
    display: flex;
    margin-left: 5%!important;
    margin-right: 5%!important;
    margin-top: -1.25rem!important;
    margin-bottom: 0!important;
    align-items: center;
    height: 60px;
    padding: 0!important;
    color: #fff;
    border-bottom: none;
    background: linear-gradient(40deg, #292d3d, #03040d)!important;
    box-shadow: 0 5px 11px 0 rgba(0, 0, 0, .18), 0 4px 15px 0 rgba(0, 0, 0, .15);
}

.modal-title {
    display: flex;
    width: 100%;
    padding: 16px;
    font-family: Metropolis, sans-serif;
    font-weight: 600;
    font-size: 16px;
    align-items: center;
    min-height: 100%;
    margin-bottom: 0;
}

.btn-close {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    margin: 0;
    color: #fff !important;
    opacity: 1;
    background-image: none;
}

.btn-close i {
    color: #fff;
    line-height: 1;
}

.close-btn {
    border: 0;
    margin: 16px 16px 0px 16px;
    padding: 13.44px 16px;
    color: #fff;
    background: #292d3d;
    font-weight: 500;
    font-size: 13px;
}
</style>
